import React from 'react'
import { Screen } from '../../common/layout/Screen'

import styled from 'styled-components'

export const TermsScreen = () => {

  return (
    <Screen>
      <DefaultText>
      <StrongText>Terms of Service<br/>Effective Date: March 1, 2022<br/><br/>What you are buying</StrongText><br/>Tyco Swagg collectible art cards are NFTs (Non-Fungible Token) for you to collect, purely for fun and are not meant as investment vehicles. You understand that they have no inherent monetary value. There is absolutely no promise or guarantee that they will be worth anything more than what you and the market deem the art to be worth, which could potentially be less than what you paid. This is also true for the token SWAGG which has no intended, assumed or inherent value (1 SWAGG = 1 SWAGG), for use only as an &#x27;in-game&#x27; currency mechanism with no real-world value outside of the &#x27;metaverse&#x27;.<br/><br/>Please note that as we will be continuing the refine the genesis launch NFTs, the final artwork may differ from that shown on the website, which is included for illustration purposes only.<br/><br/>The name and Intellectual Property involved in the &quot;Tyco Swagg&quot; NFT project remains owned by the team.<br/><br/><StrongText>No Guarantees or Future Promises</StrongText><br/>While the Tyco Swagg team have outlined some activities in the roadmap section of this website and the discord, much of this is contingent upon a successful genesis launch (i.e. a sell out). The legal landscape around NFTs and associated technologies moves rapidly which may also prevent the team from delivering some of the things that it hopes to do in future. When you purchase any Tyco Swagg NFT from the genesis launch or secondary channels, you agree that you are simply receiving a piece of art in exchange for your funds. Any future benefits are ancillary to this purchase and not to be taken into consideration with your initial purchase. You agree that you are not relying on any future commitments by Tyco Swagg in using this site and participating in the purchase of any Tyco Swagg NFTs.<br/><br/><StrongText>Taxes</StrongText><br/>You are entirely responsible for any tax liability which may arise from minting or reselling your Tyco Swagg NFTs.<br/>
      </DefaultText>
    </Screen>
  )
}



export const DefaultText = styled.div`
    display: block;
    width: 100%;
    height: 100%;
    max-height: 100%;
    max-width: 100%;
    margin-top: 0px;
    margin-bottom: 100px;
    -webkit-box-pack: center;
    -webkit-justify-content: center;
    -ms-flex-pack: center;
    justify-content: center;
    -webkit-box-align: start;
    -webkit-align-items: flex-start;
    -ms-flex-align: start;
    align-items: flex-start;
    color: rgba(43,22,21,1);
    font-size: 18px;
    text-align: left;
    padding-left: 50px;
    padding-right: 50px;
    font-weight: 300;

`;

export const StrongText = styled.p`
  font-weight: 700;
`;
